<button class="btn btn-secondary" (click)="getImageSliderView()">{{buttonText}}</button>
<app-image-slider *ngIf="showSliderPic" [(showSlider)]="showSliderPic" [imageUrls]="showimages" [photoUploadedBy]="uploadedBy"></app-image-slider>